import { ISinglePageCheckout } from '~/components/templates/Checkout/SinglePageCheckout/hooks'
import { LocalStorageKeys } from '~/enums/localStorageKeys'
import useSessionStorage from '~/hooks/useSessionStorage'

export const useUserData = () => {
  const [userData, setUserData] = useSessionStorage<Partial<ISinglePageCheckout>>(LocalStorageKeys.userData, {})

  return { userData, setUserData }
}
